import { render, staticRenderFns } from "./OutOfOfficeCard.vue?vue&type=template&id=cfaaf9c4"
import script from "./OutOfOfficeCard.vue?vue&type=script&lang=js"
export * from "./OutOfOfficeCard.vue?vue&type=script&lang=js"
import style0 from "./OutOfOfficeCard.vue?vue&type=style&index=0&id=cfaaf9c4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports